module.exports = __webpack_public_path__ + "static/media/bytt-nn-12.310f629a.mp3";